import { render, staticRenderFns } from "./CardCell.vue?vue&type=template&id=fa7d8338&scoped=true"
import script from "./CardCell.vue?vue&type=script&lang=js"
export * from "./CardCell.vue?vue&type=script&lang=js"
import style0 from "./CardCell.vue?vue&type=style&index=0&id=fa7d8338&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7d8338",
  null
  
)

export default component.exports